import { render, staticRenderFns } from "./MainSidebar.vue?vue&type=template&id=190dc85a&scoped=true"
import script from "./MainSidebar.vue?vue&type=script&lang=js"
export * from "./MainSidebar.vue?vue&type=script&lang=js"
import style0 from "./MainSidebar.vue?vue&type=style&index=0&id=190dc85a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190dc85a",
  null
  
)

export default component.exports